import React, {FC, ReactNode, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {sidebarState} from "../../../store/sidebar";
import {IState} from "../../../types/state";
import {ArrowRoundedDown12x7Svg} from '../../../svg'
import cls from "./category.module.scss"
import {TranslationsType} from "../../../types/homePageTypes";

const CustomCategorySidebar: FC<{ children: ReactNode, translationsData: TranslationsType }> = (
    {
                                                                                                    children,
                                                                                                    translationsData
                                                                                                }) => {
    const sidebarOpen = useSelector((state: IState) => state.sidebar.open)
    const bodyRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch()

    const sideBarOpened = {
        "true": cls["block-sidebar--open"],
        "false": ""
    }
    const openedSideBarClass: Record<string, string> = {
        "true": cls.open,
        "false": ""
    }

    return (
        <div className={cls["shop-layout__sidebar"]}>
            <div
                className={`${cls["block-sidebar"]} ${cls["block-sidebar--offcanvas--mobile"]} `}>
                <div className={cls["block-sidebar__body"]} ref={bodyRef}>
                    <div className={cls["block-sidebar__header"]}>
                        <div
                            className={`${cls["block-sidebar__title"]} ${cls.tablet}`}
                            onClick={() => dispatch(sidebarState())}
                        >
                            {translationsData?.Filters}
                            <button
                                className={`${cls.filter__item} ${openedSideBarClass[`${sidebarOpen}`]}`}
                                type="button"
                                aria-label="Open Product Filter Sidebar"
                                tabIndex={0}
                            >
                                <ArrowRoundedDown12x7Svg/>
                            </button>
                        </div>
                    </div>
                    <div className={`${cls["block-sidebar__item"]} ${sideBarOpened[`${sidebarOpen}`]}`}>
                        <div className={cls["widget-categories"]}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default CustomCategorySidebar;
